<template>
    <div class="submenu-container" v-show="projects.length > 0">
        <p style="text-align: center;margin-top:-1em;margin-bottom: 2em;font-size: 16px;font-weight: bold;color:#555;">— 更多案例 —</p>
        <div class="submenu">
            <!-- 轮播容器（实现一屏三卡） -->
            <el-carousel ref="carousel" height="280px" :initial-index="activeIndex" indicator-position="none"
                :autoplay="true" arrow="always" :loop="true" @change="handleCarouselChange" :interval="10000">
                <el-carousel-item v-for="(group, index) in groupedProjects" :key="index">
                    <div class="carousel-group">
                        <div class="project-card-wrapper" v-for="(project, i) in group" :key="i"
                            @click="checkProject(activeIndex * 3 + i)">
                            <el-card class="project-card" :body-style="{ padding: 0 }"
                                :class="{ 'active': currentProjectIndex == (activeIndex * 3 + i) }">
                                <!-- 封面图 - 优化后的图片路径 -->
                                <img class="cover" :src="getCoverImage(project.cover)" :alt="project.title + '项目封面'"
                                    @error="handleImageError($event, project)" />
                                <div class="arrow" v-show="project.hasDetail"
                                    @click="showProjectDetail(activeIndex * 3 + i)">详情></div>
                                <!-- 标题 + 绿色背景底板 -->
                                <div class="footer">
                                    <span class="title" :title="project.title">{{ project.title }}</span>
                                </div>
                            </el-card>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>

            <!-- 底部自定义导航点 -->
            <div class="carousel-indicators">
                <span v-for="(n, i) in projects.length" :key="i" class="indicator"
                    :class="{ active: i === currentProjectIndex }" @click="handleIndicatorClick(i)"></span>
            </div>
        </div>
    </div>
</template>

<script>
import { active } from 'sortablejs';

export default {
    props:['type','projects'],
    data() {
        return {
            activeIndex: 0, // 当前激活的卡片页面索引（每页显示3个项目）
            currentProjectIndex: 0
        }
    },
    watch:{
        activeIndex(val){
            this.currentProjectIndex=val*3
        }
    },
    computed: {
        // 将项目按每3个一组进行分组
        groupedProjects() {
            const groups = [];
            for (let i = 0; i < this.projects.length; i += 3) {
                groups.push(this.projects.slice(i, i + 3));
            }
            return groups;
        }
    },
    methods: {
        // 获取项目封面图片路径
        getCoverImage(coverName) {
            try {
                return require(`@/assets/img/case/`+this.type+`/`+this.type+`_${coverName}_suoluetu.png`);
            } catch (error) {
                console.warn(`图片加载失败: ${coverName}`, error);
                // return this.defaultCover;
            }
        },

        // 处理图片加载错误
        handleImageError(event, project) {
            event.target.src = this.defaultCover;
            console.warn(`项目 ${project.title} 的封面图片加载失败，已使用默认图片`);
        },

        // 点击底部导航点切换卡片
        handleIndicatorClick(index) {
            this.currentProjectIndex = index;
            this.activeIndex = parseInt(index / 3)
            this.$refs.carousel.setActiveItem(this.activeIndex);
        },

        // 卡片切换时更新激活索引
        handleCarouselChange(index) {
            this.activeIndex = index;
        },

        checkProject(index) {
            this.currentProjectIndex = index
            this.activeIndex = parseInt(index / 3)
            this.$refs.carousel.setActiveItem(this.activeIndex);
            if(this.projects[index].hasDetail)
            {
                this.showProjectDetail(index)
            }
        },
        showProjectDetail(index) {            
            this.$emit('change', index);
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/case.less';
</style>